import { LIST_PROVINCE_STATES_BY_COUNTRY } from "@/services/constant/apiPath";
import { ccwpApi } from "@/services";

// Define a service using a base URL and expected endpoints
export const countryStateListApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountryStateListData: builder.query<any,void>({
      query: () => "Common/ListAllCountries",
    }),
    getStateByCountryId: builder.query<any, string>({
      query: (countryId) => LIST_PROVINCE_STATES_BY_COUNTRY + countryId,
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCountryStateListDataQuery, useGetStateByCountryIdQuery } =
  countryStateListApi;
